import { FC, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { ThemeProvider } from '@mui/material'

import { createExperienceTheme } from 'common/theme/createExperienceTheme'
import { ApplicationState } from 'store'

import { useExperience } from './ExperienceContext'
import { isExperiencePreviewEnabled } from './experienceOverride'

interface ExperienceThemeProviderProps {
  children: ReactNode
}

/**
 * Themes its subtree, legacy views included, with the chosen experience. Applies the next theme
 * only while the experience preview is enabled (dev/QA).
 */
const ExperienceThemeProvider: FC<ExperienceThemeProviderProps> = ({ children }) => {
  const { experience } = useExperience()
  const mode = useSelector((state: ApplicationState) => state.layout.theme)
  const themedExperience = isExperiencePreviewEnabled() ? experience : 'legacy'
  return (
    <ThemeProvider theme={createExperienceTheme(themedExperience, mode)}>{children}</ThemeProvider>
  )
}

export default ExperienceThemeProvider
